import QuinielazoService from "@/services/QuinielazoService";

export const namespaced = true;

export const state = {
	user: null,
	users: [],
	googleUser: null,
	facebookUser: null,
	seguidores: null,
	seguidos: null
};

export const mutations = {
	SET_USER(state, userData) {
		state.user = userData;
		localStorage.setItem("user", JSON.stringify(userData));
    	//Add the token to axios headers
    	QuinielazoService.setToken(userData.token);
    },
    SET_GOOGLE_USER(state, googleUser){
    	state.googleUser = googleUser
    },
    SET_FACEBOOK_USER(state, facebookUser){
    	state.facebookUser = facebookUser
    },
    SET_USERS(state, users) {
    	state.users = users;
    },
    CLEAR_USER_DATA(){
    	localStorage.removeItem("user");
    	state.user = null
    	state.users = []
    	location.reload()
    },
    ADD_FOLLOW(state, follower){
    	state.user.user.siguiendo.push(follower)
    	localStorage.setItem("user", JSON.stringify(state.user));
    },
    REMOVE_FOLLOW(state, follower){ //Unfollow user
    	state.user.user.siguiendo = state.user.user.siguiendo.filter(id => {
			return id !== follower;
		});
		localStorage.setItem("user", JSON.stringify(state.user));
    },
    RESTAR_PUNTOS(state, puntos){
    	state.user.user.puntos = state.user.user.puntos - puntos
    	localStorage.setItem("user", JSON.stringify(state.user));
    },
    UPDATE_USER_CHANGED(state, user){
    	state.user.user = user;
    	localStorage.setItem("user", JSON.stringify(state.user));
    },
    NEW_FOLLOWER(state){
    	state.user.user.seguidores_count++
    	localStorage.setItem("user", JSON.stringify(state.user));
    },
    REMOVE_FOLLOWER(state){
    	state.user.user.seguidores_count--
    	localStorage.setItem("user", JSON.stringify(state.user));	
	},
	SET_USER_PROFILE(state, profile){
		state.user.user.name = profile.name
		state.user.user.image = profile.image
		localStorage.setItem("user", JSON.stringify(state.user));
	},
	SET_SEGUIDORES(state, seguidores){
		state.seguidores = seguidores
	},
	SET_SEGUIDOS(state, seguidos) {
		state.seguidos = seguidos
	}
};

export const actions = {
	register({ commit, dispatch }, credentials) {
		return QuinielazoService.register(credentials)
		.then(resp => {
			commit("SET_USER", resp.data);
		})
		.catch(err => {
			if (err.response !=undefined && err.response.status == 422) {
				return err.response
			}
			return dispatch('handleError',err)
		});
	},
	login({ commit, dispatch }, credentials) {
		return QuinielazoService.login(credentials)
		.then(resp => {
			commit("SET_USER", resp.data);
		})
		.catch(err => {
			if (err.response != undefined && err.response.status == 422) {
				return err.response
			}
			return dispatch('handleError', err)
		});
	},
	loginGoogle({commit, dispatch}, data){
		//Guardar Google user independientemente que haga login o no..
		commit('SET_GOOGLE_USER', data.googleUser)

		return QuinielazoService.loginGoogle({ token: data.token })
		.then(resp => {
			commit("SET_USER", resp.data);
		})
		.catch(err => {
			return dispatch('handleError', err)
		})
	},
	loginFacebook({commit, dispatch}, data){
		//Guardar Facebook user independientemente que haga login o no..
		commit('SET_FACEBOOK_USER', data.facebookUser)

		return QuinielazoService.loginFacebook({ token: data.token })
		.then(resp => {
			commit("SET_USER", resp.data);
		})
		.catch(err => {
			return dispatch('handleError', err)
		})
	},
	fetchUsers({ commit, dispatch }) {
		QuinielazoService.getUsers()
		.then(resp => {
			commit("SET_USERS", resp.data);
		})
		.catch(err => {
			dispatch(
				"notification/add",
				{
					type: "error",
					message:
					"Hubo un error " +
					(err.response.data.error
						? "<strong>" + err.response.data.error + "</strong>"
						: "")
				},
				{ root: true }
				);
		});
	},
	passrecover({dispatch}, email) {
		return QuinielazoService.passEmail(email)
		.then(resp => {
			//Se enviara un email desde backend
			if (resp.data.success == true) {
				return true
			}else if(resp.data.success == false){
				dispatch("notification/add",
				{
					type: "error",
					message:"Este email no esta registrado"
				},
				{ root: true });
				return false
			}
		})
		.catch(err => {
			return {error: dispatch('handleError', err)}
		});
	},
	changePass({dispatch}, data) {
		return QuinielazoService.changePass(data)
		.then(resp => {
			if(resp.data.success == false){
				dispatch("notification/add",
				{
					type: "error",
					message: "<p>Su email esta mal escrito o este enlace ya expiró</p>"
				},
				{ root: true });
				return false
			}else{
				return true
			}
		})
		.catch(err => {
			for (let error in err.response.data) {
				dispatch("notification/add",
				{
					type: "error",
					message: "<p>" + err.response.data[error] + "</p>"
				},
				{ root: true });
			}
		});
	},
	followUser({commit, dispatch}, data){ //Nuevo jugador que sigues
		return QuinielazoService.followUser(data)
		.then(() => {
			commit("ADD_FOLLOW",data.id)
			dispatch('jugadores/newFollower',null,{root: true})
		})
		.catch(err => {
			dispatch("notification/add",{
				type: "error",
				message: "Hubo un error de conexión"
			},
			{ root: true });
			return err
		})
	},
	unfollowUser({commit, dispatch}, data){
		return QuinielazoService.unfollowUser(data)
		.then(() => {
			commit('REMOVE_FOLLOW', data.id)
			dispatch('jugadores/unFollow',null, {root: true})
		})
		.catch(err => {
			dispatch("notification/add",{
				type: "error",
				message: "Hubo un error de conexión"
			},
			{ root: true });

			return err
		})
	},
	updateUserChanged({commit}, user){
		commit('UPDATE_USER_CHANGED', user)
	},
	newFollower({commit}){ //Nuevo jugador te sigue
		commit('NEW_FOLLOWER')
	},
	removeFollower({commit}){
		commit('REMOVE_FOLLOWER')
	},
	fetchLoggedInUser({ commit }){
		return QuinielazoService.getLoggedInUser()
		.then(resp => {
			commit('UPDATE_USER_CHANGED', resp.data)
		})
		.catch(err => {
			console.log(err)
		})
	},
	handleError({dispatch}, err){

		if(!err.response){
			dispatch("notification/add",
			{
				type: "error",
				message: "No hay conexión con API"
			},
			{ root: true });
		}else if(err.response.data != undefined){
			if (err.response.data.error !== "El usuario no esta registrado." && err.response.data.error !== "El email no existe." ) {
				dispatch("notification/add",
				{
					type: "error",
					message: err.response.data.error
				},
				{ root: true });
			}else{
				dispatch("notification/add",
				{
					type: "alert",
					message: "El usuario no esta registrado"
				},
				{ root: true });
				err.response.usuarioNoRegistrado = true
			}
			return err.response
		}else{
			dispatch("notification/add",
			{
					type: "error",
					message:
					"Hubo un error " +
					(err.response.data.error
						? "<strong>" + err.response.data.error + "</strong>"
						: "")
			},{ root: true });
		}

		return err;
	},
	verifyEmail(context, token){
		return QuinielazoService.verificarEmail(token)
		.then(resp => {
			return resp
		})
		.catch(err => {
			return err.response.data
		})
	},
	reSendVerificationEmail(){
		return QuinielazoService.reenviarVerificacion()
		.then(resp => {
			return resp
		})
		.catch(err => {
			console.log(err)
			return err
		})
	},
	updateUserProfile({commit, dispatch}, data){
		return QuinielazoService.updatePerfil(data)
		.then(() => {
			commit('SET_USER_PROFILE', data)
			dispatch("notification/add",
			{
				type: "success",
				message: "Se actualizo tu perfil"
			},
			{ root: true });
		})
	},
	changePassword({commit, dispatch}, data){
		return QuinielazoService.changePassword(data)
		.then(() => {
			dispatch("notification/add",
			{
				type: "success",
				message: "Se actualizo tu contraseña"
			},
			{ root: true });
			if (!state.user.user.pass) {
				let user = state.user.user
				user.pass = true
				commit('UPDATE_USER_CHANGED', user)
			}
		})
		.catch(err => {
			return err
		})
	},
	enviarPuntos({commit,dispatch}, data){
		return QuinielazoService.enviarPuntos(data)
		.then(() => {
			dispatch("notification/add",
			{
				type: "success",
				message: "Se enviaron los puntos"
			},
			{ root: true });
			let user = state.user.user
			user.puntos = user.puntos - data.puntos

			data.jugador.puntos = data.jugador.puntos + data.puntos;	
			dispatch("jugadores/updateJugador", data.jugador,{root: true});
			commit('UPDATE_USER_CHANGED',user)
		})
		.catch(err => {
			dispatch("notification/add",
			{
				type: "error",
				message: "Hubo un error al enviar los puntos " + err.response.data
			},
			{ root: true });
			return err
		})
	},
	fetchFollowers({commit}){
		return QuinielazoService.getUserSeguidores()
		.then(resp => {
			commit('SET_SEGUIDORES',resp.data)
		})
	},
	fetchFollowing({ commit }) {
		return QuinielazoService.getUserSeguidos()
		.then(resp => {
			commit('SET_SEGUIDOS', resp.data)
		})
	}
};
